function CaravanCleanRequestTransformer(Util, jsonMapper) {

	function transform(intermediateRequest, userInput) {
		delete intermediateRequest.caravanForm;

		var caravan = intermediateRequest.caravans[0];
		var policyHolders = intermediateRequest.policyHolders[0];

		delete caravan.cost;
		delete caravan.existingDamage;
		delete caravan.financeWith;
		delete caravan.finance;
		delete caravan.regoNumber;
		delete caravan.sumInsuredAmount;
		delete caravan.whenDidYouBuyMonth;
		delete caravan.whenDidYouBuyYear;
		delete caravan.security;
		delete caravan.locationDescription;
		delete caravan.primaryUse;
		delete caravan.vehicleSubType;

		// Remove the subtype if the vehicle is any of these types
		if ( caravan.caravanType !== 'caravan' && caravan.caravanType !== 'campertrailer' && caravan.caravanType !== 'goodscarryingtrailer' ) {
			delete caravan.caravanSubType;
		}

		if ( caravan.drivers ) {
			caravan.drivers.forEach(function(policyDriver) {
				delete policyDriver.driver._HTMLID;
				delete policyDriver.driver.$$hashKey;
				delete policyDriver.driver._aggregator;

				delete policyDriver.driver.maxNoClaimBonus;
				delete policyDriver.driver.title;
				delete policyDriver.driver.yearsHeld;
				delete policyDriver.driver.fourYears_chargedOrConvictedOffences;
				delete policyDriver.driver.fourYears_chargedOrConvictedOffencesDetails;
				delete policyDriver.driver.fourYears_licenceRSDC;
				delete policyDriver.driver.fourYears_licenceRSDCDetails;
				delete policyDriver.driver.fourYears_vehicleAccidentsClaims;
				delete policyDriver.driver.fourYears_vehicleAccidentsClaimsDetails;
				delete policyDriver.driver.tenYears_chargedOrConvictedOffences;
				delete policyDriver.driver.tenYears_chargedOrConvictedOffencesDetails;

				/**
				* Guidewire creates duplicate records of other drivers criminal histories
				* if the driverHistory is sent as an empty array :)
				* For now this has been commented out and moved to PublicIDTransformer as that
				* is creating an array when going through and transforming public ID's for a list.  This behaviour should be changed for empty lists.
				* After changing that, this can be commented back in and removed from publicIDTransformer.
				if ( policyDriver.driver.driverHistory
					&& Array.isArray(policyDriver.driver.driverHistory)
					&& policyDriver.driver.driverHistory.length == 0 )
					delete policyDriver.driver.driverHistory;
				*/
			});
		};

		if ( policyHolders.contact ) {
			delete policyHolders.contact._HTMLID;
			delete policyHolders.contact.$$hashKey;
			delete policyHolders.contact._aggregator;

			delete policyHolders.contact.anyInfringements;
			delete policyHolders.contact.anyLostLicences;
			delete policyHolders.contact.mainPolicyHolder;

			delete policyHolders.contact.fourYears_chargedOrConvictedOffences;
			delete policyHolders.contact.fourYears_chargedOrConvictedOffencesDetails;
			delete policyHolders.contact.fourYears_licenceRSDC;
			delete policyHolders.contact.fourYears_licenceRSDCDetails;
			delete policyHolders.contact.fourYears_bikeAccidentsClaims;
			delete policyHolders.contact.fourYears_bikeAccidentsClaimsDetails;
			delete policyHolders.contact.tenYears_chargedOrConvictedOffences;
			delete policyHolders.contact.tenYears_chargedOrConvictedOffencesDetails;
		}



		if ( ! intermediateRequest.email )
			delete intermediateRequest.email ;

		return intermediateRequest;
	}

	return {
		transform: transform
	}
}
